<template>
  <div>
    <AttrGroup
      title="触发方式"
      :show-add="addEnable"
      :card="true"
      :visible="!!condition?.children.length"
      @add="() => onAddCondition('compare')"
    >
      <div class="py-1">
        <ConditionWraper
          :addable="addEnable"
          :condition="condition"
          :disabled="!!attrDisabled"
          @delete=" (paramId:string)=> onDelCondition(paramId)"
          @add=" (compareId:string)=> onAddCondition('compare-param',compareId)"
          @update="(id:string, data:any) => iftttStore.updateCondition(ifttt.id, id, data)"
        />
      </div>
    </AttrGroup>
  </div>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue';
import { useEditorStore } from '@/store/use-editor-store';
import { GlobalConfig } from '@/services/gloabl.config';
import { Modal } from 'ant-design-vue';
import { useIFTTTStore } from '@/store/use-ifttt-store';
import ConditionWraper from './Condition/ConditionWraper.vue';
const props = defineProps({
  ifttt: {
    type: Object as PropType<IFTTT>,
    required: true
  }
});

const editorStore = useEditorStore();
const iftttStore = useIFTTTStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const condition = computed(() => props.ifttt.condition);
const onAddCondition = (
  flag: 'compare' | 'compare-param',
  compareId?: string
) => {
  if (attrDisabled.value) return;
  if (!addEnable.value) {
    Modal.warning({
      title: '添加受限',
      content:
        '最大可添加' +
        GlobalConfig.shapeConditionMaxCount +
        '个条件，无法继续添加',
      okText: '知道了'
    });
    return;
  }
  iftttStore.addCondition(props.ifttt.id, { flag, compareId });
};

const onDelCondition = (paramId: string) => {
  if (conditionCount.value <= 1) {
    Modal.warning({
      title: '无法删除',
      content: '至少需要一个条件',
      okText: '知道了'
    });
  } else {
    iftttStore.deleteCondition(props.ifttt.id, paramId);
  }
};

const conditionCount = computed(() => {
  let count = 0;
  props.ifttt.condition?.children.forEach((compare) => {
    compare.children?.forEach(() => {
      count++;
    });
  });
  return count;
});
const addEnable = computed(
  () => conditionCount.value < GlobalConfig.shapeConditionMaxCount
);
</script>

<style scoped>
:deep(.trigger-input) * {
  text-align: center;
}

._grid {
  display: grid;
  grid-template-columns: 20px 1fr;
}
</style>
